import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { VersionMismatchPageComponent } from './version-mismatch-page.component';
import { VersionMismatchGuard } from './version-mismatch.guard';

const routes: Routes = [
  {
    path: '',
    component: VersionMismatchPageComponent,
    canActivate: [VersionMismatchGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VersionMismatchPageRoutingModule {}
